import type { ActionInputBuffer, BufferedInputEntry } from './action-input-buffer';
import type { BufferedAction, InputFrame } from './input-frame';

const ACTION_PRIORITY: Readonly<Record<BufferedAction, number>> = {
  super: 6,
  skill1: 5,
  skill2: 4,
  heavy: 3,
  light: 2,
  jump: 1,
};

export interface HeldInputResolution {
  readonly horizontal: -1 | 0 | 1;
  readonly crouch: boolean;
  readonly guard: boolean;
}

export interface ResolvedInput {
  readonly held: HeldInputResolution;
  readonly buffered: Readonly<BufferedInputEntry> | null;
}

export const resolveHeldInput = (frame: InputFrame): HeldInputResolution => Object.freeze({
  horizontal: frame.left === frame.right ? 0 : frame.left ? -1 : 1,
  crouch: frame.down,
  guard: frame.guard,
});

export const resolveInput = (frame: InputFrame, buffer: ActionInputBuffer): ResolvedInput => {
  const candidates = [...buffer.getCandidates()].sort((left, right) => {
    const priorityDifference = ACTION_PRIORITY[right.action] - ACTION_PRIORITY[left.action];
    return priorityDifference === 0 ? left.sequence - right.sequence : priorityDifference;
  });
  return Object.freeze({ held: resolveHeldInput(frame), buffered: candidates[0] ?? null });
};
